( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
      let wasDesktop = $( window ).width() > 1280;

      if ( wasDesktop ) {
        // on desktop, open the first menu on each dropdown panel
        $( '.navigation-four .primary-menu-first__default-open' ).trigger( 'click' );

        // ADA close menu when focus shifts outside of it
        $( '.navigation-four .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }
      $( window ).on( 'resize.navigation-four', function() {
        const isDesktop = $( window ).width() > 1280;

        // We just crossed from desktop (XL) to smaller
        if ( !isDesktop && wasDesktop ) {
          // Close the first menu on each dropdown panel
          $( '.navigation-four .primary-menu-first__default-open' ).each( function() {
            const $trigger = $( this );

            // Only "close" it if it's currently open (has whatever class your toggle adds)
            if ( $trigger.hasClass( 'is-open' ) ) {
              $trigger.trigger( 'click' );
            }
          } );
        }

        wasDesktop = isDesktop;
      } );
    },
  };

  app.registerComponent( 'navigation-four', COMPONENT );
} )( app );
